import { restApiClient } from '@/datasources';

export const UPDATE_CUSTOMER_PHONE_ROUTE = '/online/customers/phone';

export async function updateCustomerPhone(phoneDigits: string): Promise<void> {
  await restApiClient.put(UPDATE_CUSTOMER_PHONE_ROUTE, { phone: phoneDigits });
}
